import React, { useState, useEffect } from 'react';
import styled from '@emotion/styled';
import { theme } from '../../../themes/default-theme';
import { ReactSVG } from 'react-svg';
import Link from '../NextLink';


const FooterSocialContainer = styled.div`
    display: flex;
    justify-content: center;
    ${theme.breakpoints.up('md')} {
        gap: 14px;
    }
    ${theme.breakpoints.down('sm')} {
        gap: 29px;
    }
`


const Social = styled(ReactSVG)`
    &, svg {
        ${theme.breakpoints.up('md')} {
            width: 20px;
            height: 20px;
        }
        ${theme.breakpoints.down('sm')} {
            width: 18px;
            height: 18px;
        }
    }
`

const FooterSocial = (props) => {


    const [data, setData] = useState(props);
    const [dealerData, setDealerData] = useState(false);

    useEffect(() => {

        try {
            const component = document.getElementById('staticly-dynamics-component-SocialFooterLinks');
            const jsonData = window.staticly.data && window.staticly.data.SocialFooterLinks ? window.staticly.data.SocialFooterLinks : null

            if (component && !jsonData) {
                component.remove();
                return
            }

            if (jsonData) {
                setData(jsonData);
                setDealerData(true);
                component && component.remove();
            }
        } catch {
            // do nothing
        }
    }, []);

    const hbString = `{{#staticlyDynamic data from="template.dealer" id="SocialFooterLinks" component="src/components/navigation/FooterNav/SocialLinks.js"}}{{/staticlyDynamic}}`

    return (
        !process.env.DEALER_SITE ?
            <FooterSocialContainer>
                <Link legacyBehavior href={props.assignedDomain === 'jayco.co.nz' ? "https://www.facebook.com/jayconewzealand/" : "https://www.facebook.com/JaycoAust/"}>
                    <a aria-label={'Facebook'} target="_blank">
                        <Social src={'/assets/new-footer-facebook.svg'} />
                    </a>
                </Link>
                <Link legacyBehavior href={"https://www.instagram.com/jaycoaustralia/"}>
                    <a aria-label={'Instagram'} target="_blank">
                        <Social src={'/assets/new-footer-instagram.svg'} />
                    </a>
                </Link>

                <Link legacyBehavior href={"https://www.youtube.com/jaycoaustraliaofficial/"}>
                    <a aria-label={'Youtube'} target="_blank">
                        <Social src={'/assets/new-footer-youtube.svg'} />
                    </a>
                </Link>
                <Link legacyBehavior href={"https://www.linkedin.com/company/jayco-australia/"}>
                    <a aria-label={'Linkedin'} target="_blank">
                        <Social src={'/assets/new-footer-linkedin.svg'} />
                    </a>
                </Link>
            </FooterSocialContainer>
            :
            (!dealerData) ?
                <div dangerouslySetInnerHTML={{ __html: hbString }}>
                </div>

                :

                <FooterSocialContainer>
                    {data.facebook &&
                        <Link legacyBehavior href={data.facebook}>
                            <a aria-label={'Facebook'} target="_blank">
                                <Social src={'/assets/new-footer-facebook.svg'} />
                            </a>
                        </Link>
                    }
                    {data.instagram &&
                        <Link legacyBehavior href={data.instagram}>
                            <a aria-label={'Instagram'} target="_blank">
                                <Social src={'/assets/new-footer-instagram.svg'} />
                            </a>
                        </Link>
                    }
                    {data.youtube &&
                        <Link legacyBehavior href={data.youtube}>
                            <a aria-label={'Youtube'} target="_blank">
                                <Social src={'/assets/new-footer-youtube.svg'} />
                            </a>
                        </Link>
                    }
                    {data.linkedin &&
                        <Link legacyBehavior href={data.linkedin}>
                            <a aria-label={'Linkedin'} target="_blank">
                                <Social src={'/assets/new-footer-linkedin.svg'} />
                            </a>
                        </Link>
                    }
                </FooterSocialContainer>



    )
}

FooterSocial.propTypes = {
}

export default FooterSocial

